<div [formGroup]="userForm">
  <h2>User Information Form</h2>
  <div formArrayName="users">
    <div *ngFor="let userControl of userControls(); let i = index" [formGroupName]="i">
      <h3>User {{ i + 1 }}</h3>
      <div>
        <label for="name">Name:</label>
        <input type="text" id="name" [formControlName]="'name'" />
      </div>
      <div formArrayName="phoneNumbers">
        <div *ngFor="let phoneControl of userControl.get('phoneNumbers').controls; let j = index" [formGroupName]="j">
          <div>
            <label for="phoneNumber">Phone Number:</label>
            <input type="text" id="phoneNumber" [formControlName]="'phoneNumber'" />
          </div>
        </div>
      </div>
      <button (click)="addPhoneNumber(userControl.get('phoneNumbers'))">Add Phone Number</button>
      <button (click)="removePhoneNumber(userControl.get('phoneNumbers'))" [disabled]="userControl.get('phoneNumbers').controls.length === 1">Remove Phone Number</button>
    </div>
  </div>
  <button (click)="addUser()">Add User</button>
  <button (click)="removeUser()" [disabled]="userControls.length === 1">Remove User</button>
  <button (click)="submitForm()">Submit</button>
</div>
